var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-view"},[_c('iframe',{attrs:{"width":"100%","id":_vm.id,"frameborder":"0","height":_vm.dynaHeight,"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }